export default __webpack_public_path__ + "static/media/profile4.563e6955.png";